export default "__VITE_ASSET__Cgo643Xa__"